/**
 * Auth utility functions
 */

import { sanitizeUserAvatarPaths, cleanLegacyAvatarCache } from './avatarUtils';

/**
 * Check if user is authenticated
 * @returns {boolean} - True if token exists in localStorage
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem('access_token');
  return !!token;
};

/**
 * Get current user from localStorage
 * Automatically sanitizes legacy avatar paths
 * @returns {object|null} - User object or null
 */
export const getCurrentUser = () => {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    const user = JSON.parse(userStr);
    // Sanitize any legacy avatar paths that might be cached
    return sanitizeUserAvatarPaths(user);
  } catch (error) {
    console.error('Error parsing user from localStorage:', error);
    return null;
  }
};

/**
 * Get auth token
 * @returns {string|null} - Token or null
 */
export const getToken = () => {
  return localStorage.getItem('access_token');
};

/**
 * Clear auth data (logout)
 */
export const clearAuth = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('user');
};

/**
 * Set auth data (login)
 * Automatically cleans any legacy avatar paths before storing
 * @param {string} token - JWT token
 * @param {object} user - User object
 */
export const setAuth = (token, user) => {
  localStorage.setItem('access_token', token);
  // Sanitize user object to remove legacy avatar URLs
  const sanitizedUser = sanitizeUserAvatarPaths(user);
  localStorage.setItem('user', JSON.stringify(sanitizedUser));
};

/**
 * Initialize auth - call on app startup
 * Cleans any legacy avatar URLs from cached user data
 */
export const initAuth = () => {
  cleanLegacyAvatarCache();
};
